/*
  Base file for stub.
  This is where all the actual stub code will go.
*/

// REQUIRED IMPORTS
const $ = require('jquery');
import run from '../../utilities/run';
import render from "../../utilities/render";
import {handleCustomDropdownEvents} from "../../utilities/customBootstrapDropdowns";
import { setElementsFromScope } from '../../utilities/selectorHelpers';
import ConfigPanel from "../ConfigPanel/ConfigPanel";
import { isPresent } from "../../utilities/general";
require("./html/doorLookup/doorLookup.less");
// Additional Imports...
import { docLookupFieldDropdown } from "./filter/docLookupFieldDropdown.js";
import {actionOptions} from "./filter/actionOptions.js";
import { buildExport, prepareDataToSendController, isEdit, doAjax, pushFilterSessionCacheState, retriveCriteriaObjectByOperation, isNew, isDeleteView, isOnlyLookupDataUpdate } from "../../utilities/filtersutil";
import PagableComponent from "../../components/pagableComponent";
import { createPreventDefault } from '../../utilities/general';
import SubmitModalFlow from "../../components/SubmitModalFlow/SubmitModalFlow";
import {SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT,SUCCESS_MODAL_TIMEOUT} from "../../constants";
const detailLinkHTML = require('../../utilities/filtersutil/html/detailLinkHTML.html');


import LookupTable from "../../components/lookupTable/index";
import { dataTableFilterData } from "./html/doorLookup/stores/testFilterData.js"; 
import { testColumns } from "./html/doorLookup/stores/testColumnModalData.js";
import {dataTableComponentData, dataTableNewData} from "./html/doorLookup/stores/testData.js";

import { statusOptions, statusOptionsExample } from "./html/doorLookup/stores/statusOptions.js";
import { testSavedViews, testNewSavedView } from "./html/doorLookup/stores/savedViews.js";
const targetSelector = "#dock-lookup";

let actionCellDropdownTemplate = require('../../components/lookupTable/html/utilRenderTemplates/actionCellDropdown.html');
let actionCellDropdownItemTemplate = require('../../components/lookupTable/html/utilRenderTemplates/actionCellDropdownItem.html');
let actionHeaderDropdownTemplate = require('../../components/lookupTable/html/utilRenderTemplates/actionHeaderDropdown.html');

// Modal Html to use
const modalHtml = require('../../sharedHtml/modal.html');
const modalAlertHtml = require("../../components/SubmitModalFlow/html/alertModal.html");
const _ = require("underscore");


let dockDetails = require("./html/doorLookup/html/dockDetails.html");
let statusPillRenderTemplate = require("./html/doorLookup/html/statusPillsTemplate.html")

// Action List Rendering Functions...
import { createDropdownRenderers } from "./html/doorLookup/utilityScripts/renderers.js";

run(targetSelector, (mainEl)=>{
  const lookupData = mainEl.data("dock-lookup-data");
  const lookupTable = mainEl.find("#lookup-wrapper");
  //const shouldCheckCache = mainEl.data("should-check-cache");
  const shouldCheckCache = $(targetSelector).data("should-check-cache");
  const criteriaObjectFromServer = $(targetSelector).data("filter-criteria-from-server");
  //const criteriaObjectFromServer  =  mainEl.data("filter-criteria-from-server");
  const filterItemsUrl =  mainEl.data("filter-items-url");
  const editUrl =  mainEl.data("edit-url");
  const savedViews  =  mainEl.data("saved-view");
  const saveViewURL  =  mainEl.data("save-view-url");
  const deleteViewURL  =  mainEl.data("delete-view-url");
  const editPermission =  mainEl.data("dock-edit-permission"); 
  const viewDockDetailUrl = mainEl.data("dock-details-url");
  const portletNamespace = mainEl.data("portlet-namespace");
  const deleteItemUrl =  mainEl.data("delete-item-url");
  const generateExportUrl = mainEl.data("export-url");
  const activateItemUrl =  $(targetSelector).data("activate-item-url");
  const bulkActivateDeactivateBtnUrl = mainEl.data("bulk-activate-dock-url");
  const pageRefreshUrl=mainEl.data("page-refresh-url");
  let lookupColumns;
  let targetObject = "";
  let exportModal = new buildExport();
  var submitModalFlow = new SubmitModalFlow();
  submitModalFlow.init();
    let selectedRows = "";
  // END: REQUIRED TO LOAD STUB

  // START: REAL CODE
 
  let els = {};
  let elsModal = {};

  //for rendering the status pills
  let pillStatusClasses = {
    "Active": "q-pill-blue",
    "Inactive": "q-pill-blue-border",
  }

  let actionList = statusOptionsExample;
  if(shouldCheckCache)
    {
		targetObject = retriveCriteriaObjectByOperation(criteriaObjectFromServer,"like");
	}
  // START: Actual Code
  function renderPill(data, type, row) {
    return data;
  }

  let deActivateModal, activateModal;

  // Create Constants based on functions required for action lists.
  const { renderActionWrap } = createDropdownRenderers(actionList);

  const elsMap = {
    copydockdoorBtn: ".copy-dock-door",
    editdockdoorBtn: ".edit-dock-door",
    activatedockdoorBtn: ".activate-dock-door",
    deactivatedockdoorBtn: ".deactivate-dock-door",
  }

  const elsModalMap = {
  };

  let dockLookupTable = new LookupTable({
    target: $("#lookup-wrapper"),
    // REQUIRED - Set which data should be visible for mobile
    mobileColumns: [
      {
          data: "docDeactiveActive",
          title: "Actions",
          orderable: false,
          render: renderActionWrap1,
          class: 'dtc-action-column'
        },
        // END: Example Actions Column
        {
          data: "docName",
          title: "Dock Door Name",
          render: dockDoorActionBtns,
          class: 'dtc-min-width-sm',
        },
        {
          data: "docUse",
          title: "Door Uses",
          class: 'dtc-min-width-sm',
        },
        {
          data: "docAppointmentTypes",
          title: "Appointment Types",
          render: customAppointmentTypes,
          class: 'dtc-min-width-lg',
        },
         {
           data: "docDeactiveActive",
           title: "Status",
           render: statusPillRender,
           class: 'dtc-min-width-sm',
         },
         {
           data: "docUseFacilitiesSchedule",
           title: "Schedule Type",
           render: scheduleTypeRender,
           class: 'dtc-min-width-sm',
         },
        {
          data: "docModifiedDate",
          title: "Date Modified",
          render: formateDate,
          class: 'dtc-min-width-sm',
        },
        {
          data: "docModifiedBy",
          title: "Modified By",
          class: 'dtc-min-width-sm',
        }
    ],

    // OPTIONAL: Set whether users can create new views
    // newSavedViews: false,
    // OPTIONAL: Set Saved View Array
    savedViews: savedViews,
    // OPTIONAL: Set whether search bar will display
    tableSearch: true,
    tableSearchInput: {
      value: (targetObject != "" ? targetObject.value[0] : ""),
      // Not required
      //optional value to prefill input
      //value: "Search",
      placeholder: 'Search'
    },
    // CONDITIONALLY OPTIONAL: search input info, has to be used with tableSearchInput
    tableSearchDropdown: {
      // selected property is optional
      columns: docLookupFieldDropdown     
    },
    //OPTIONAL, defaults to false: set this to true if you need column with select boxes for bulk select
    bulkSelect: true,
    // REQUIRED - Data Table specific settings
    dataTable: {
      // use same settings you would if you were just calling a dataTable normally
      data: lookupData.content,
      // REQUIRED: Even if empty, needs to be here.
      columnDefs: [{
        className: "custom-class", targets: [1]
                  }],
      // CONDITIONAL REQUIREMENT: If using bulk select, this needs to be defined so the table doesn't try to order the checkbox column.
      order: [[8, 'desc']],
      columns: [
        // START: Example Actions Column
        {
          data: "docDeactiveActive",
          title: "Actions",
          orderable: false,
          render: renderActionWrap1,
          class: 'dtc-action-column'
        },
        // END: Example Actions Column
        {
          data: "docName",
          title: "Dock Door Name",
          render: dockDoorActionBtns,
          class: 'dtc-min-width-sm',
        },
        {
          data: "docUse",
          title: "Door Uses",
          class: 'dtc-min-width-sm',
        },
        {
          data: "docAppointmentTypes",
          title: "Appointment Types",
          render: customAppointmentTypes,
          class: 'dtc-min-width-lg',
        },
         {
           data: "docDeactiveActive",
           title: "Status",
           render: statusPillRender,
           class: 'dtc-min-width-sm',
         },
         {
           data: "docUseFacilitiesSchedule",
           title: "Schedule Type",
           render: scheduleTypeRender,
           class: 'dtc-min-width-sm',
         },
        {
          data: "docModifiedDate",
          title: "Date Modified",
          render: formateDate,
          class: 'dtc-min-width-sm',
        },
        {
          data: "docModifiedBy",
          title: "Modified By",
          class: 'dtc-min-width-sm',
        }
      ]
    },
    paginationData: lookupData.page,
    filterModal: {
      // REQUIRED: Sets title of modal
      title: "Filter Orders",
      // REQUIRED: Sets unique part of subtitle string.
      tableType: "orders"
    },
    onBulkSelectChange: function() {
        selectedRows = dockLookupTable.getBulkSelectedData();
      $("th.dtc-action-column").html(renderActionHeaderWrap());
      // console.log(selectedRows.length);
      // console.log(selectedRows);
      if (selectedRows.length >= 2) {
        $(".action-header-btn .base-btn").removeClass('disabled');
      } else {
        $(".action-header-btn .base-btn").addClass('disabled');
      };
    },
    onFetch: function () {
      let currentData = dockLookupTable.generateData();
      dockLookupTable.showLoadingOverlay();

     	  //Withing lookup screen onFetch fun. can be called for different level of actions - like New view , Edit view, Delete view and Search, remove pills
         if(isOnlyLookupDataUpdate(currentData)){
          setTimeout(() => {
            doAjax({url: filterItemsUrl, success: filterSuccessFun, error: errorFun,data:prepareDataToSendController(currentData)});
          },SUCCESS_MODAL_TIMEOUT);
        }else if(isNew(currentData)){
          setTimeout(() => {
            doAjax({url: saveViewURL, success: savedViewSuccess, error: errorFun, data:prepareDataToSendController(currentData)});
          },SUCCESS_MODAL_TIMEOUT);
        }else if(isEdit(currentData)){
          setTimeout(() => {
            doAjax({url: saveViewURL, success: savedEditViewSuccess, error: errorFun, data:prepareDataToSendController(currentData)});
          },SUCCESS_MODAL_TIMEOUT);
        }else if(isDeleteView(currentData)){
          setTimeout(() => {
            doAjax({url: deleteViewURL, success: delteViewScussFun, error: errorFun, data:prepareDataToSendController(currentData)});
          },SUCCESS_MODAL_TIMEOUT);
        }
      }
  });
  dockLookupTable.init();
  var table = $("#lookup-wrapper .data-table-component").DataTable();

  function filterSuccessFun(data){
		let items = data.content;
		let page = data.page;
		dockLookupTable.setNewData(items);
		dockLookupTable.setPaginationData(page)
		pushFilterSessionCacheState();
		dockLookupTable.hideLoadingOverlay();
    setExportData(dockLookupTable.generateData());
	}

	function savedViewSuccess(data){
    let items = data.lookupItems.content;
    let page = data.lookupItems.page;
    dockLookupTable.setNewData(items);
    dockLookupTable.setPaginationData(page);
    dockLookupTable.setNewSavedViewData(data.savedView, "newSavedView");
  	pushFilterSessionCacheState();
    dockLookupTable.hideLoadingOverlay();
    setExportData(dockLookupTable.generateData());
	}

	function savedEditViewSuccess(data){
    let items = data.lookupItems.content;
    let page = data.lookupItems.page;
    dockLookupTable.setNewData(items);
    dockLookupTable.setPaginationData(page);
    dockLookupTable.setNewSavedViewData(data.savedView, data.savedView.target);
  	pushFilterSessionCacheState();
    dockLookupTable.hideLoadingOverlay();
    setExportData(dockLookupTable.generateData());
	}

	function delteViewScussFun(data){
		let items = data.lookupItems.content;
	  let page = data.lookupItems.page;
		dockLookupTable.removeSavedView(data.target);
		dockLookupTable.setNewData(items);
	  dockLookupTable.setPaginationData(page);
		dockLookupTable.hideLoadingOverlay();
    setExportData(dockLookupTable.generateData());
	}

  function errorFun(data){
    dockLookupTable.hideLoadingOverlay();
  }
  

  function init() {
    setElements();
    setElementsInModals();
    bindElements();
  }

  function setElements() {
    setElementsFromScope(els, elsMap, mainEl);
  }

  function setElementsInModals() {
    const body = $('body');
    setElementsFromScope(elsModal, elsModalMap, body);
  }

  function bindElements() {
     

  }

  $('body').on( 'click', '.deactivate-dock', function (e) {
    e.preventDefault();
    let pIndex = $(this).closest('.dropdown-menu').data('parent-index');
		// Get the row based on the parent...
		let parent = $(".dropdown-parent-" + pIndex).parents('tr');
    // Get the row data
    let row = table.row(parent);
    var submitModalFlow = new SubmitModalFlow({
      confirmModalTitle: 'Deactivate Dock Door',
      modalDialogClass: "q-modal-dialog-500",
      confirmModalBody: `<div class="q-pad-all-xl">Once deactivated, this dock door will no longer be available for appointments. This dock door can be reactivated at any time.</div>`,
      confirmModalBtnText: 'Deactivate Dock Door',
      onConfirmClick: function() {
        submitModalFlow.showLoadingModal();
        deleteProduct(row, row.data());
        function deleteProduct(row, dock) {
          $.ajax({
            url: deleteItemUrl,
            type: 'POST',
            dataType: 'JSON',
            data: {
              docId: dock.docId,
              activeDeativeFlag: "N"
            },
            success: function(data){
              if(data.response == "success") {
                var d = row.data();
                d.docDeactiveActive=$.trim(data.docDeactiveActive);
                location.href=pageRefreshUrl;
                row.data(d).draw();
                submitModalFlow.showSuccessModal();
                setTimeout(function() {
                  submitModalFlow.hideAllModals();
                }, window.constants.SUCCESS_MODAL_TIMEOUT);
              }else{
                submitModalFlow.showFailureModal();
              }
            },
            error: function(data){
              submitModalFlow.hideAllModals();
            }
          });
        };
      }
    });
    submitModalFlow.init();
    submitModalFlow.showConfirmModal();
  });


  $('body').on( 'click', '.activate-dock', function (e) {
    e.preventDefault();
    let pIndex = $(this).closest('.dropdown-menu').data('parent-index');
		// Get the row based on the parent...
		let parent = $(".dropdown-parent-" + pIndex).parents('tr');
    // Get the row data
    let row = table.row(parent);
    var submitModalFlow = new SubmitModalFlow({
      confirmModalTitle: 'Activate Dock Door',
      modalDialogClass: "q-modal-dialog-500",
      confirmModalBody: `<div class="q-pad-all-xl">Once activated, this dock door will no longer be available for appointments. This dock door can be deactivated at any time.</div>`,
      confirmModalBtnText: 'Activate Dock Door',
      onConfirmClick: function() {
        submitModalFlow.showLoadingModal();
        activateProduct(row, row.data());
        function activateProduct(row, dock) {
          $.ajax({
            url: deleteItemUrl,
            type: 'POST',
            dataType: 'JSON',
            data: {
              docId: dock.docId,
              activeDeativeFlag: "Y"
            },
            success: function(data){
              if(data.response == "success") {
                var d = row.data();
                d.docDeactiveActive="Y";
                location.href=pageRefreshUrl;
                row.data(d).draw();
                submitModalFlow.showSuccessModal();
                setTimeout(function() {
                  submitModalFlow.hideAllModals();
                }, window.constants.SUCCESS_MODAL_TIMEOUT);
              }else{
                submitModalFlow.showFailureModal();
              }
            },
            error: function(data){
              submitModalFlow.hideAllModals();
            }
          });
        };
      }
    });
    submitModalFlow.init();
    submitModalFlow.showConfirmModal();
  });

  $('body').on( 'click', '.edit-dock', function (e) {
    e.preventDefault();
    let pIndex = $(this).closest('.dropdown-menu').data('parent-index');
		// Get the row based on the parent...
		let parent = $(".dropdown-parent-" + pIndex).parents('tr');
    // Get the row data
    let row = table.row(parent);
    let mydocId = row.data().docId;
    location.href = editUrl + "&docId=" + mydocId;
  });

  
  $('body').on( 'click', '.copy-dock', function (e) {
    e.preventDefault();
    let pIndex = $(this).closest('.dropdown-menu').data('parent-index');
		// Get the row based on the parent...
		let parent = $(".dropdown-parent-" + pIndex).parents('tr');
    // Get the row data
    let row = table.row(parent);
    let mydocId = row.data().docId;
    location.href = editUrl + "&docId=" + mydocId+"&copy=true";
  });

  //Actions
  function renderActionWrap1(data, type, row, meta) {
    let newRender;
    let statusTarget = actionOptions["actions"];
    newRender = render(
      actionCellDropdownTemplate, {
        list: renderActionCellList(statusTarget, data, row),
        index: meta.row
      }
    );
    return newRender;
  }

  function renderActionHeaderWrap() {
    let statusTarget = actionOptions['all'];
    let newRender;
    let data = "";
    let row = "";
    newRender = render(
      actionHeaderDropdownTemplate, {
        list: renderActionCellList(statusTarget, data, row)
      }
    );
    return newRender;
  }

  function renderActionCellList(list, data, row) {
    let renderedList = _(list).map((item) => {
      return render(
        actionCellDropdownItemTemplate, neededActions(data, row, item)
      );
    });
    return renderedList.join('');
  }

  function neededActions(data, row, item){
    var action = {};
    if(item.title === 'Activate/Deactivate'){
      if(data === "Y"){
        action = {
          icon: 'toggle-off',
          title: 'Deactivate',
          cls: "deactivate-dock",
          disabled: false
        };
      }else{
        action = {
          icon: 'toggle-on',
          title: 'Activate',
          cls: "activate-dock",
          disabled: false
        };
      }
    }else if(item.title === 'Copy'){
      if(row.product != null && row.product.prdHazardMaterial){
        action = {
          icon: 'clone',
          title: 'Copy',
          cls: "",
          disabled: true
        };
      }else{
        action = {
          icon: 'clone',
          title: 'Copy',
          cls: "copy-dock",
          disabled: false
        };
      }
    }else if(item.title === 'Activate Selected Docks'){
      action = {
        icon: item.icon,
        title: item.title,
        cls: item.cls,
        disabled: checkDisableForGivenAction(data, row, item.title)
      };
    }else if(item.title === 'Deactivate Selected Docks'){
      action = {
        icon: item.icon,
        title: item.title,
        cls: item.cls,
        disabled: checkDisableForGivenAction(data, row, item.title)
      };
    }else{
      action = {
        icon: item.icon,
        title: item.title,
        cls: item.cls,
        disabled: item.disabled
      };
    }
    return action;
  }

  function checkDisableForGivenAction(data, row, actionName) {
    let isTrue = false;
    _(selectedRows).map((item)=>{
      if(callBusinessLogicToDisableAction(item.data.docDeactiveActive, item.data, actionName)){
    	  if (!isTrue){
      		isTrue = true;
      	}
      }
    });
    return isTrue;
	};

	function callBusinessLogicToDisableAction(data, row, actionName) {
		if (/*editPermission &&*/ isPresent(data)) {
			if(actionName === "Activate Selected Docks"){
				if(data === "Y") {
					return true;
				}else{
					return false;
				}
			}
			else if(actionName === "Deactivate Selected Docks"){
				if (data === "N") {
					return true
				}else{
					return false;
				}
			}
		}
	}


  //Bulk Activate and Deactivate

  function shallAllowClick(currentObj) {
    return !($(currentObj).hasClass("disabled"));
  }

    $('body').on('click', '.bulk-activate-dock', function () {
    if (shallAllowClick(this)) {
      $("#bulkActivatedock").modal("show");
    }
  });

  $('#modalBulkActivateDock').click(function () {
    submitModalFlow.showLoadingModal();
    bulkActivateDeativateOrg('Y');
  });

  $('body').on('click', '.bulk-deactivate-dock', function () {
    if (shallAllowClick(this)) {
      $("#bulkDeActivateDock").modal("show");
    }
  });

  $('#modalBulkDeActivateDock').click(function () {
    submitModalFlow.showLoadingModal();
    bulkActivateDeativateOrg('N');
  });


  function bulkActivateDeativateOrg(val) {
    $.ajax({
      url: bulkActivateDeactivateBtnUrl,
      type: 'POST',
      dataType: 'JSON',
      data: {
        [`${portletNamespace}docId`]: getAllSelectedDockIds(),
        activeDeativeFlag: val
      },
      success: function (data) {
        if (data.response === "success") {
          _(selectedRows).map((item) => {
            let currentRow = $(".data-table-component").dataTable().api().row(item.rowIndex);
            let d = currentRow.data();
            d.docDeactiveActive = val;
            currentRow.data(d).draw();
          });
          dockLookupTable.uncheckAllSelected();
          $(".action-header-btn .base-btn").addClass('disabled');
          setTimeout(function () {
            submitModalFlow.hideAllModals();
          }, SUCCESS_MODAL_TIMEOUT);

        }
      },
      error: function () {
        submitModalFlow.hideAllModals();
      }
    });
  }

   function getAllSelectedDockIds() {
    let docIds = new Array();
    _(selectedRows).map((item) => {
      docIds.push(item.data.docId);
    });
    return JSON.stringify(docIds);
  }
  



  //for enabling the modal for subscription
  function dockDoorActionBtns(data, type, row) {
     let detailPageHTML = render(
      detailLinkHTML, {
        renderURL: viewDockDetailUrl,
        portletNamespace: portletNamespace,
        id: row.docId,
        idName: "docId",
        displayVal: data
      }
    );
    return detailPageHTML;
  }


  function statusPillRender(data, type, row) {
    if (data === 'Y') {
      return "<div class='q-marg-all-xs-at-md q-pill q-pill-blue q-pill-table'>Active</div>";
    } else {
      return "<div class='q-marg-all-xs-at-md q-pill q-pill-blue-border q-pill-table'>Inactive</div>";
    }
  }

  function scheduleTypeRender(data, type, row) {
    if (data === 'Y') {
      return "Master";
    } else {
      return "Individual";
    }
  }

  function customAppointmentTypes(data) {
    if (data != null) {
      return data.split(',').join(', ');
    } else {
      return "";
    }
  }

   function formateDate(createdDate, type, data){
    if(createdDate != null && createdDate != "") {
      let date = new Date(createdDate); //createdDate is long time format
      let month = date.getMonth() + 1;
      return (month.toString().length > 1 ? month : "0" + month) + "/" + date.getDate() + "/" + date.getFullYear();
    } else {
      return "";
    }
  }


  function initExport() {
		let exportObj  =  {
       title: mainEl.data("export-popup-title"),
            exportAttemptTextPart1Lang: mainEl.data("export-attempt-text-part1"),
            exportAttemptTextPart2Lang: mainEl.data("export-attempt-text-part2"),
            exportMaxLimitLang: mainEl.data("export-max-row-limit")
		};
		exportModal.init(exportObj);
		exportModal.bindExportEvent();
	}

	function setExportData(currentData) {
		exportModal.buildExportBasicURL(generateExportUrl,currentData);
		exportModal.setExportCount(currentData.totalElements);
	}

	initExport();
	setExportData(dockLookupTable.generateData());


  handleCustomDropdownEvents();
  $("th.dtc-action-column").html(renderActionHeaderWrap());

  init();
  // END: REAL CODE
 
});


// WEBPACK FOOTER //
// ./src/pages/dockConfigurations/dockLookup.js